import { clickAddThreadToSpaceEvent, clickSwapThreadSpaceEvent, } from '#pplx/frontend/apps/ask/events/thread/analytics.js';
import { useSpaceSelectModal } from '#pplx/frontend/apps/ask/space-select-modal/hooks/useSpaceSelectModal.js';
import { assertUnreachableValue } from '#pplx/frontend/common/type_utils/unreachableValue.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { useCallback } from 'react';
// Kept apart from the read-state interactions so legacy project rows can use it without
// bundling the read-state and notification code into the Projects chunk.
export function useAddOrMoveToProjectFactory() {
    const { openSpaceSelectModal } = useSpaceSelectModal({});
    const { track } = useInstrumentation();
    return useCallback(({ contextUUID, entryUUID, project }) => () => {
        const thread = {
            ...(entryUUID ? { entryUUID } : {}),
            contextUUID,
            frontendContextUUID: contextUUID,
        };
        switch (project.kind) {
            case 'none':
                track(clickAddThreadToSpaceEvent({
                    name: 'click add thread to space',
                    data: { contextUUID, isBookmark: false },
                }));
                openSpaceSelectModal({
                    mode: 'add',
                    threads: [{ ...thread, currentCollectionUuid: undefined }],
                    omittedSpaces: undefined,
                });
                return;
            case 'in-project': {
                const { collectionUUID, collectionSlug } = project;
                track(clickSwapThreadSpaceEvent({
                    name: 'click swap thread space',
                    data: { contextUUID, isFromBookmark: false, collectionUUID },
                }));
                openSpaceSelectModal({
                    mode: 'move',
                    threads: [
                        {
                            ...thread,
                            currentCollectionUuid: collectionUUID,
                            ...(collectionSlug ? { currentCollectionSlug: collectionSlug } : {}),
                        },
                    ],
                    omittedSpaces: [collectionUUID],
                });
                return;
            }
            default:
                assertUnreachableValue(project);
        }
    }, [openSpaceSelectModal, track]);
}
//# sourceMappingURL=useAddOrMoveToProject.js.map